const allFileFields = document.querySelectorAll(".form-field--file");

try {
    if (allFileFields.length) {
        allFileFields.forEach((inputField) => {
            const button = inputField.querySelector("button");
            const input = inputField.querySelector("input");
            const filenameNode = inputField.querySelector("span.filename");

            if (button && input) {
                button.addEventListener("click", () => {
                    input.click();
                });
            }

            input.addEventListener("change", () => {
                let file = input.files;
                if (file && file[0]) {
                    const filename = file[0].name;
                    filenameNode.innerHTML = filename;
                }
            });
        });
    }
} catch (err) {
    console.error(err);
}
